import React, { useState } from "react";
import { Link } from "react-router-dom";
import { COOKIE_NOTICE } from "../lib/policies";

const KEY = "pkx_cookie_notice_v1";

// Aviso de armazenamento do navegador: o site só usa o essencial (login, idioma, preferências), sem publicidade nem rastreadores de terceiros.
export default function CookieNotice() {
  const [show, setShow] = useState(() => { try { return localStorage.getItem(KEY) !== "1"; } catch { return false; } });
  if (!show) return null;
  const ok = () => { try { localStorage.setItem(KEY, "1"); } catch { /* ok */ } setShow(false); };
  return (
    <div role="region" aria-label="Aviso de cookies" style={{ position: "fixed", left: 12, right: 12, bottom: 12, zIndex: 2147483000, maxWidth: 760, margin: "0 auto", background: "rgba(14,8,10,.96)", border: "1px solid rgba(255,255,255,.14)", borderRadius: 14, padding: "14px 16px", display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", boxShadow: "0 10px 40px rgba(0,0,0,.6)", color: "#e8dfe2", fontSize: 13, lineHeight: 1.5 }}>
      <span style={{ flex: "1 1 320px" }}>{COOKIE_NOTICE.text} <Link to="/privacidade" style={{ textDecoration: "underline" }}>Política de Privacidade</Link></span>
      <button type="button" onClick={ok} className="pkx-btn primary sm">Entendi</button>
    </div>
  );
}
